import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["monthlyPrice", "yearlyPrice", "monthlyButton", "yearlyButton", "planKey"]

  connect() {
    this.showMonthly()
  }

  showMonthly() {
    this.monthlyPriceTargets.forEach(el => el.classList.remove("hidden"))
    this.yearlyPriceTargets.forEach(el => el.classList.add("hidden"))
    this.monthlyButtonTarget.classList.add("bg-brand-500", "text-white")
    this.monthlyButtonTarget.classList.remove("text-gray-600")
    this.yearlyButtonTarget.classList.remove("bg-brand-500", "text-white")
    this.yearlyButtonTarget.classList.add("text-gray-600")
    this.planKeyTargets.forEach(el => {
      const base = el.dataset.planBase
      el.value = base + "_monthly"
    })
  }

  showYearly() {
    this.monthlyPriceTargets.forEach(el => el.classList.add("hidden"))
    this.yearlyPriceTargets.forEach(el => el.classList.remove("hidden"))
    this.yearlyButtonTarget.classList.add("bg-brand-500", "text-white")
    this.yearlyButtonTarget.classList.remove("text-gray-600")
    this.monthlyButtonTarget.classList.remove("bg-brand-500", "text-white")
    this.monthlyButtonTarget.classList.add("text-gray-600")
    this.planKeyTargets.forEach(el => {
      const base = el.dataset.planBase
      el.value = base + "_yearly"
    })
  }
}
